import { FC } from 'react';
import { Outlet, Navigate } from 'react-router-dom';

import { useAuthStore } from '@/stores/useAuthStore';

type AuthenticatedRoutesProps = {
  allowedRoles?: string[];
};

const AuthenticatedRoutes: FC<AuthenticatedRoutesProps> = ({
  allowedRoles,
}) => {
  const { isLoggedIn, role } = useAuthStore();

  if (!isLoggedIn) {
    return <Navigate to="/sign-in" />;
  }

  if (allowedRoles && !allowedRoles.includes(role)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default AuthenticatedRoutes;
